import { render } from "./Activiteit.vue?vue&type=template&id=224e219a&scoped=true"
import script from "./Activiteit.vue?vue&type=script&lang=js"
export * from "./Activiteit.vue?vue&type=script&lang=js"

import "./Activiteit.vue?vue&type=style&index=0&id=224e219a&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224e219a"]])

export default __exports__